import {createApp, watch} from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { createI18n } from 'vue-i18n';
import en from './locales/en';
import fa from './locales/fa';

import "bootstrap/dist/css/bootstrap.css"
//import "bootstrap/dist/css/bootstrap.rtl.min.css"
import "@/assets/css/slick.css"
import "@/assets/css/icofont.min.css"
import "@/assets/css/animate.css"
import "@/assets/css/nice-select.css"
import "@/assets/css/magnific-popup.css"
import "@/assets/css/style.css"
import "@/assets/css/myStyle.css"
import "bootstrap"
import "jquery-nice-select"
import "jquery"
import 'swiper/swiper-bundle.css';

import $ from '@/jquery';

const languageStorageKey = 'boostaminophen.locale';
let initialLocale = 'fa';

try {
    const savedLocale = localStorage.getItem(languageStorageKey);
    if (savedLocale === 'en' || savedLocale === 'fa') {
        initialLocale = savedLocale;
    }
} catch {
    // Keep the default language when browser storage is unavailable.
}

const i18n = createI18n({
    locale: initialLocale,
    legacy: false,
    messages: {
        en,
        fa,
    }
});

watch(i18n.global.locale, (locale) => {
    try {
        localStorage.setItem(languageStorageKey, locale);
    } catch {
        // Language switching still works when browser storage is unavailable.
    }
}, {flush: 'sync'});

const app = createApp(App);
//app.config.globalProperties.counterUp = counterUp;
app.use(store);
app.use(router);
app.use(i18n);
app.use($);
app.mount('#app')
